export enum SettlementTrigger {
    CANCELLED_BY_HOST = 'CANCELLED_BY_HOST',
    CANCELLED_BY_TENANT_WITH_FIFTY_PERCENT_REFUND = 'CANCELLED_BY_TENANT_WITH_FIFTY_PERCENT_REFUND',
    CANCELLED_BY_TENANT_WITH_CANCELLATION_FEE = 'CANCELLED_BY_TENANT_WITH_CANCELLATION_FEE',
    CANCELLED_BY_TENANT_WITH_NO_REFUND = 'CANCELLED_BY_TENANT_WITH_NO_REFUND',
    SETTLED_WITH_REFUND = 'SETTLED_WITH_REFUND',
    PAYOUT_INITIATED_AFTER_CHECK_IN = 'PAYOUT_INITIATED_AFTER_CHECK_IN',
    CANCELLED_BY_TENANT_WITH_FULL_REFUND = 'CANCELLED_BY_TENANT_WITH_FULL_REFUND',
}
